import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';

export default function AdminDashboardPublicationCategories() {
  const { csrfToken } = useAuth();
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState('');
  const [editingCategory, setEditingCategory] = useState(null);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  // دریافت لیست دسته‌بندی‌ها
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get('/api/publication-categories', { withCredentials: true });
        setCategories(data);
      } catch {
        setError('❌ Error fetching categories');
      }
    })();
  }, []);

  // افزودن دسته جدید
  async function addCategory(e) {
    e.preventDefault();
    try {
      const { data } = await axios.post(
        '/api/publication-categories',
        { name },
        { headers: { 'X-CSRF-Token': csrfToken }, withCredentials: true }
      );
      setCategories(prev => [...prev, data]);
      setName('');
      setMessage('✅ Category added successfully!');
    } catch {
      setError('❌ Error adding category');
    }
  }

  // شروع ویرایش
  function startEdit(c) {
    setEditingCategory(c);
    setName(c.name);
  }

  // بروزرسانی دسته
  async function updateCategory(e) {
    e.preventDefault();
    try {
      const { data } = await axios.put(
        `/api/publication-categories/${editingCategory._id}`,
        { name },
        { headers: { 'X-CSRF-Token': csrfToken }, withCredentials: true }
      );
      setCategories(prev => prev.map(cat => cat._id === data._id ? data : cat));
      setEditingCategory(null);
      setName('');
      setMessage('✅ Category updated successfully!');
    } catch {
      setError('❌ Error updating category');
    }
  }

  // حذف دسته
  async function deleteCategory(id) {
    try {
      await axios.delete(`/api/publication-categories/${id}`, {
        headers: { 'X-CSRF-Token': csrfToken },
        withCredentials: true,
      });
      setCategories(prev => prev.filter(c => c._id !== id));
      setMessage('✅ Category deleted');
    } catch {
      setError('❌ Error deleting category');
    }
  }

  return (
    <div className="container py-5">
      <h1 className="h4 mb-4">Manage Publication Categories</h1>

      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-danger">{error}</div>}

      {/* فرم افزودن/ویرایش */}
      <form onSubmit={editingCategory ? updateCategory : addCategory} className="card p-4 shadow-sm mb-4">
        <div className="mb-3">
          <label className="form-label">Category Name</label>
          <input
            className="form-control"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
        </div>
        <button className="btn btn-success">
          {editingCategory ? 'Update Category' : 'Add Category'}
        </button>
        {editingCategory && (
          <button
            type="button"
            className="btn btn-secondary ms-2"
            onClick={() => { setEditingCategory(null); setName(''); }}
          >
            Cancel
          </button>
        )}
      </form>

      {/* لیست دسته‌بندی‌ها */}
      <h2 className="h6 text-muted mb-3">Existing Categories</h2>
      <ul className="list-group">
        {categories.map(c => (
          <li key={c._id} className="list-group-item d-flex justify-content-between align-items-center">
            <span>{c.name}</span>
            <div>
              <button className="btn btn-sm btn-warning me-2" onClick={() => startEdit(c)}>Edit</button>
              <button className="btn btn-sm btn-danger" onClick={() => deleteCategory(c._id)}>Delete</button>
            </div>
          </li>
        ))}
        {categories.length === 0 && (
          <li className="list-group-item text-muted text-center">No categories found</li>
        )}
      </ul>
    </div>
  );
}
